import toastr from "toastr";
import Swal from "sweetalert2";
import __ from 'lodash';
import swalOptions from "./swalOptions";

/**
 *
 * @param element
 * @param ev
 * @param selector
 * @param handler
 * @param options
 */
window.delegate = (element, ev, selector, handler, options = {}) => {
    element.addEventListener(ev, function (event) {
        let t = event.target;
        while (t && t !== this) {
            if (t.matches(selector)) {
                handler.call(t, event);
            }
            t = t.parentNode;
        }
    }, options);
};

document.querySelectorAll('[data-confirm]').forEach(el => {
    el.addEventListener('click', async (e) => {
        e.preventDefault();

        const result = await Swal.fire({
            ...swalOptions,
            text: el.dataset.confirm
        });

        if (result.isConfirmed) {
            location.href = el.href;
        }
    });
});

window.scrollToSmoothly = (pos, time) => {
    let currentPos = window.pageYOffset;
    let start = null;
    if (time == null) time = 500;
    pos = +pos;
    time = +time;
    window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        let progress = currentTime - start;
        if (currentPos < pos) {
            window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
        } else {
            window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
        }
        if (progress < time) {
            window.requestAnimationFrame(step);
        } else {
            window.scrollTo(0, pos);
        }
    });
}

/**
 *
 * @param columns
 * @param rows
 * @param el
 */
window.toggleEl = (columns, rows, el) => {
    if (el.classList.contains('pointer-events-none') && el.classList.contains('opacity-50')) {
        el.classList.remove('pointer-events-none', 'opacity-50');
        columns.forEach(c => {
            c.classList.remove('pointer-events-none', 'opacity-20');
        });
        rows.forEach(r => {
            r.classList.remove('pointer-events-none', 'opacity-20');
        });
    } else {
        el.classList.add('pointer-events-none', 'opacity-50');
        rows.forEach(r => {
            r.classList.add('pointer-events-none', 'opacity-20');
        });
        columns.forEach(c => {
            c.classList.add('pointer-events-none', 'opacity-20');
        });
    }
};

/**
 *
 * @param columns
 * @param rows
 * @param buttons
 * @param el
 */
window.toggleButtons = (columns, rows, buttons, el) => {
    [...columns].forEach(col => {
        if (col.classList.contains('pointer-events-none') && col.classList.contains('opacity-20')) {
            col.classList.remove('pointer-events-none', 'opacity-20');
            buttons.classList.remove('pointer-events-none', 'opacity-20');
            rows.forEach(r => {
                r.classList.remove('pointer-events-none', 'opacity-20');
            });
        } else {
            col.classList.add('pointer-events-none', 'opacity-20');
            buttons.classList.add('pointer-events-none', 'opacity-20');
            rows.forEach(r => {
                r.classList.add('pointer-events-none', 'opacity-20');
            });
            el.classList.remove('pointer-events-none', 'opacity-20');
        }
    });
}

window.copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text).then(async () => {
            await messages({
                success: true,
                message: __('Copied to clipboard.').toString(),
            });
        });
    } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";

        document.body.prepend(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
            await messages({
                success: true,
                message: __('Copied to clipboard.').toString(),
            });
        } catch (error) {
            await messages({
                errors: true,
                message: __('Failed to copy to clipboard!').toString(),
            });
            console.error(error);
        } finally {
            textArea.remove();
        }
    }
};

window.ensureBackdrop = (onClick = null) => {
    if (document.getElementById('backdrop')) return;

    const backDrop = document.createElement('div');
    backDrop.classList.add('bg-gray-900/50', 'dark:bg-gray-900/80', 'fixed', 'inset-0', 'z-30');
    backDrop.id = 'backdrop';
    backDrop.setAttribute('drawer-backdrop', '');
    document.body.appendChild(backDrop);

    backDrop.addEventListener('click', () => {
        if (typeof onClick === 'function') onClick();
        window.removeBackdrop();
        document.body.classList.remove('overflow-hidden');
    });
};

window.removeBackdrop = () => {
    document.getElementById('backdrop')?.remove();
};

window.on = (element, type, selector, handler) => {
    element.addEventListener(type, (event) => {
        let el = event.target.closest(selector);
        if (el) handler.call(el, event);
    });
};

/**
 *
 * @param data
 * @param position
 */
window.messages = (data, position = "toast-bottom-right") => {
    toastr.options = {
        closeButton: true,
        progressBar: true,
        positionClass: position,
        timeOut: 3000,

    };

    if (data.errors) {
        toastr['error'](data.message, __('System message'));
    }

    if (data.success) {
        toastr['success'](data.message);
    }

    if (data.warning) {
        toastr['warning'](data.message);
    }

    if (data.info) {
        toastr['info'](data.message);
    }
};

window.isNumericString = (str) => {
    return str.match(/^[0-9.]+$/);
}

window.hideProgressBar = (target) => {
    setTimeout(() => {
        target.classList.add('animate__animated', 'animate__bounceOut');
    }, 2000);
};

window.closeModal = () => {
    document.querySelector('form[name="handler"]').querySelector('button[type="reset"]').click();
};
